import { NgModule } from "@angular/core";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { PiContextualSuggestionButtonComponent } from "./pi-contextual-suggestion-button.component";

@NgModule({
  imports: [UiIconModule, UiTooltipModule, LocalizationModule],
  declarations: [PiContextualSuggestionButtonComponent],
  exports: [PiContextualSuggestionButtonComponent],
  providers: [],
})
export class PiContextualSuggestionButtonModule {}
